// extracted by mini-css-extract-plugin
export default {"HeadingContainer":"TeamsHeading_HeadingContainer__7SGcI","TopContainer":"TeamsHeading_TopContainer__rUuIT","Heading":"TeamsHeading_Heading__zeUkS"};